import { render, staticRenderFns } from "./DocumentDraftingList.vue?vue&type=template&id=37c1770f&scoped=true"
import script from "./DocumentDraftingList.vue?vue&type=script&lang=js"
export * from "./DocumentDraftingList.vue?vue&type=script&lang=js"
import style0 from "./DocumentDraftingList.vue?vue&type=style&index=0&id=37c1770f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c1770f",
  null
  
)

/* custom blocks */
import block0 from "./Color.scss?vue&type=custom&index=0&blockType=link&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fadmin%2FDocumentDrafting%2FComposer%2FDocumentDraftingList.vue&scoped=true&external"
if (typeof block0 === 'function') block0(component)

export default component.exports